import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

// Utils
import { fetchWithToken } from "../../api/fetch";
import toastConfig from "../../utils/toastConfig";

/**
 * Componente para el modal de eliminación
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Boolean} props.show - Estado del modal
 * @param {Function} props.handleClose - Función para cerrar el modal
 * @param {Object} props.info - Información del elemento a eliminar
 * @param {Function} props.callBack - Función de retorno
 * @returns {JSX.Element} Componente de React
 */
const ModalDelete = ({ show, handleClose, info, callBack }) => {
  /**
   * Maneja la eliminación del elemento
   * 
   * @returns {void} No retorna nada
   */
  const handleDelete = async () => {
    const resp = await fetchWithToken(info.path, { id: info.id }, "DELETE");
    handleClose();
    if (!resp.ok) return toast.error(`${resp.msg}`, toastConfig);
    callBack();
    toast.success(resp.msg, toastConfig);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar {info.type}</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="fs-4"
          style={{
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          ¿Estás seguro que deseas eliminar a <b>{info.element}</b>?
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Cancelar
          </Button>

          <Button variant="primary" onClick={handleDelete}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDelete;
